"use client";

import Image from "next/image";

export default function ClubSection({ item, index }) {
  const isEven = index % 2 === 1;

  return (
    <section
      className={`py-12 md:py-16 lg:py-20 ${
        isEven ? "bg-[#00314d]" : "bg-white"
      }`}
    >
      <div className="max-w-[var(--max-page-width)] mx-auto px-[var(--container-padding)]">
        <div
          className={`grid gap-10 lg:gap-14 items-center ${
            isEven
              ? "lg:grid-cols-[1.4fr_1.05fr]"
              : "lg:grid-cols-[1.05fr_1.4fr]"
          }`}
        >
          {/* Image first for EVEN */}
          {isEven && <ClubImage image={item.image} />}

          {/* Text */}
          <div>
            <h2
              className={`text-3xl md:text-4xl font-extrabold tracking-tight mb-6 ${
                isEven ? "text-white" : "text-black"
              }`}
            >
              {item.title}
            </h2>

            <p
              className={`text-base md:text-lg leading-relaxed ${
                isEven ? "text-white/80" : "text-black/80"
              }`}
            >
              {item.description}
            </p>
          </div>

          {/* Image last for ODD */}
          {!isEven && <ClubImage image={item.image} />}
        </div>
      </div>
    </section>
  );
}

function ClubImage({ image }) {
  return (
    <div className="relative">
      <div className="relative w-full aspect-[16/9] lg:aspect-[21/9] overflow-hidden bg-black/5">
        <Image
          src={image}
          alt="Club activity"
          fill
          priority
          className="object-cover"
          sizes="(max-width: 1024px) 100vw, 60vw"
        />
      </div>
    </div>
  );
}
